module.exports = __webpack_public_path__ + "static/data-icon-9bf29ff1944c0a40e3c5ff5d9fb4b4ea.svg";